// Client-side role helpers.
//
// The server (cloud/workers/src/middleware/auth.js) is the source of truth
// for what a role can do — these helpers exist so the UI can HIDE controls
// that would only return 403 anyway. Keep the hierarchy in sync with the
// server's ROLE_HIERARCHY.

const ROLE_LEVEL = {
  deactivated:   -1,
  org_ro:         1,
  org_operator:  2,
  org_admin:     3,
  verso_admin:   4,
};

export function hasMinRole(userRole, minRole) {
  const u = ROLE_LEVEL[userRole] ?? 0;
  const m = ROLE_LEVEL[minRole]  ?? 0;
  return u >= m;
}

// Convenience predicates for the two access tiers the UI actually branches on.
// canOperate = "day-to-day ops" (assign/unassign, imports, patch subscriber
// contact fields). canAdmin = "destructive or credential" (create/delete,
// integration credentials, user management, status transitions).
export const canOperate = (role) => hasMinRole(role, 'org_operator');
export const canAdmin   = (role) => hasMinRole(role, 'org_admin');
